import React, { useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, ListItemText, MenuList, Paper } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import FaceIcon from "@mui/icons-material/Face";
import CheckIcon from "@mui/icons-material/Check";

const MenuPage = (props:any) => {

  const loc = useLocation()
  // console.log('loc', loc.pathname.split('/').reverse()[0])

  const [selectedItem, setSelectedItem] = useState(loc.pathname.split('/').reverse()[0]);
  // setSelectedItem();

  const handleMenuItemClick = (
    event: React.MouseEvent<HTMLLIElement>,
    index: number
  ) => {
    setSelectedItem("");
  };

  const [menu01, setMenu01] = React.useState(false);

  const ClickMenu01 = () => {
    setMenu01(!menu01);
  };

  const [menu02, setMenu02] = React.useState(false);

  const ClickMenu02 = () => {
    setMenu02(!menu02);
  };

  const [menu03, setMenu03] = React.useState(false);

  const ClickMenu03 = () => {
    setMenu03(!menu03);
  };

  const [menu04, setMenu04] = React.useState(false);

  const ClickMenu04 = () => {
    setMenu04(!menu04);
  };

  


  var nav = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  useEffect(()=> {
    // console.log('selectedItem',selectedItem)
    if(['csqa','hlsw','mmlu','tfqa','comg','hhh','wngd','drop','bolq','mmmu','vie-asg'].includes(selectedItem)){
      setMenu01(true)
    }
    else if(['memberAssignment','nvScriptList','scriptFileList','fixDataForTta','evkn','sw-worker-status','sw-inst-worker-status','km','km-worker-status','km-trs-worker-status'].includes(selectedItem)){
      setMenu02(true)
    }else if(['gncWorkLog','memberContract','workerToManager','memberList','scriptFileStatus','orgStatus','scriptConfirmStatus','scriptConfirmAssignment','cms'].includes(selectedItem)){
      setMenu03(true)
    }else{
      setMenu04(true)
    }
    
  },[])

  return (
    <Box
      sx={{ width: "300px", borderRight:"4px solid #eee" }}
    >
      <Box sx={{ padding: 2 }}>
        <MenuList>

          {["ADMIN","MANAGER"].includes(props.pageRole) ?
          <Box>

            <MenuItem onClick={ClickMenu02} >
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>No.2 지식</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu02} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

                <ListItemButton
                    selected={selectedItem === "evkn"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("evkn"); setMenu02(true); nav("/admin/eval/evkn"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>원천데이터</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "evkn" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

                <ListItemButton
                    selected={selectedItem === "sw-worker-status"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("sw-worker-status"); setMenu02(true); nav("/admin/vie/sw-worker-status"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>스와힐리어 - 작업자현황</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "sw-worker-status" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

                <ListItemButton
                    selected={selectedItem === "sw-inst-worker-status"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("sw-inst-worker-status"); setMenu02(true); nav("/admin/vie/sw-inst-worker-status"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>스와힐리어 - INST현황</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "sw-inst-worker-status" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

                <ListItemButton
                    selected={selectedItem === "km"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("km"); setMenu02(true); nav("/admin/vie/km"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>크메르어</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "km" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

                <ListItemButton
                    selected={selectedItem === "km-worker-status"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("km-worker-status"); setMenu02(true); nav("/admin/vie/km-worker-status"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>크메르어 - 작업자현황</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "km-worker-status" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>

                <ListItemButton
                    selected={selectedItem === "km-trs-worker-status"}
                    sx={{ pl: 4, fontSize:"8px" }}
                    onClick={() => { setSelectedItem("km-trs-worker-status"); setMenu02(true); nav("/admin/vie/km-trs-worker-status"); }}
                  >
                  <ListItemText
                    primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>크메르어 - 번역현황</Box>}
                    // onClick={() => }
                  />
                  <ListItemIcon>
                    {selectedItem === "km-trs-worker-status" ? <CheckIcon htmlColor="#0000FF" /> : null}
                  </ListItemIcon>
                </ListItemButton>


              </List>
            </Collapse>

            <MenuItem onClick={ClickMenu01} >
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>No.3 장문이해</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu01} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

              <ListItemButton
                  selected={selectedItem === "csqa"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("csqa"); setMenu01(true); nav("/admin/vie/task/csqa"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>01. CSQA</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "csqa" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "hlsw"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("hlsw"); setMenu01(true); nav("/admin/vie/task/hlsw"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>02. Hellaswag</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "hlsw" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "mmlu"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("mmlu"); setMenu01(true); nav("/admin/vie/task/mmlu"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>03. MMLU</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "mmlu" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "tfqa"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("tfqa"); setMenu01(true); nav("/admin/vie/task/tfqa"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>04. TruthfulQA</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "tfqa" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "comg"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("comg"); setMenu01(true); nav("/admin/vie/task/comg"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>05. Common-Gen</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "comg" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "hhh"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("hhh"); setMenu01(true); nav("/admin/vie/task/hhh"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>06. HHH</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "hhh" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "wngd"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("wngd"); setMenu01(true); nav("/admin/vie/task/wngd"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>07. Winogrande</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "wngd" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "drop"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("drop"); setMenu01(true); nav("/admin/vie/task/drop"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>08. Drop</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "drop" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "bolq"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("bolq"); setMenu01(true); nav("/admin/vie/task/bolq"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>09. BoolQ</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "bolq" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "mmmu"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("mmmu"); setMenu01(true); nav("/admin/vie/task/mmmu"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>10. MMMU</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "mmmu" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "vie-asg"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("vie-asg"); setMenu01(true); nav("/admin/vie/task/vie-asg"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>할 당</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "vie-asg" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              </List>
            </Collapse>

          </Box>
          :""}

          {props.pageRole == "ADMIN" ?
          <Box>
            <MenuItem onClick={ClickMenu03} sx={{marginTop:2}}>
              <ListItemText><Box sx={{fontWeight:700, fontSize:"20px"}}>인사 관리</Box></ListItemText>
              {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>

            <Collapse in={menu03} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>

              <ListItemButton
                  selected={selectedItem === "memberList"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("memberList");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/eval/memberList"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>회원 정보</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "memberList" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "vieWorkLog"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("vieWorkLog");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/vie/vieWorkLog"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>VIE Work Log</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "vieWorkLog" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>

              <ListItemButton
                  selected={selectedItem === "gncWorkLog"}
                  sx={{ pl: 4, fontSize:"8px" }}
                  onClick={() => { setSelectedItem("gncWorkLog");  setMenu01(false); setMenu02(false); setMenu04(false); nav("/admin/vie/gncWorkLog"); }}
                >
                <ListItemText
                  primary={<Box sx={{fontWeight:700, fontSize:"14px"}}>GNC Work Log</Box>}
                  // onClick={() => }
                />
                <ListItemIcon>
                  {selectedItem === "gncWorkLog" ? <CheckIcon htmlColor="#0000FF" /> : null}
                </ListItemIcon>
              </ListItemButton>


              </List>

            </Collapse>
          </Box>
          :""}

        </MenuList>
      </Box>
    </Box>
  );
};

export default MenuPage;
